// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Show more`
};

const de_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr anzeigen`
};

const es_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar más`
};

const fr_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Afficher plus`
};

const fi_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Näytä lisää`
};

const hi_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `और दिखाएं`
};

const ja_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `もっと見る`
};

const nl_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Toon meer`
};

const pt_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar mais`
};

const ro_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Afișează mai mult`
};

const th_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `แสดงเพิ่มเติม`
};

const ur_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `مزید دکھائیں`
};

const zh_hant1_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `顯示更多`
};

const da_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Vis mere`
};

const it_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra di più`
};

const vn_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Hiển thị thêm`
};

const ko_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `더 보기`
};

const tr_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Daha fazla göster`
};

const lv_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Rādīt vairāk`
};

const ar_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `عرض المزيد`
};

const bs_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Prikaži više`
};

const sl_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Prikaži več`
};

const id_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Tampilkan lebih banyak`
};

const sv_widget_show_more = /** @type {(inputs: {}) => string} */ () => {
	return `Visa mer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_show_more = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_show_more(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_show_more", locale)
	if (locale === "en") return en_widget_show_more(inputs)
	if (locale === "de") return de_widget_show_more(inputs)
	if (locale === "es") return es_widget_show_more(inputs)
	if (locale === "fr") return fr_widget_show_more(inputs)
	if (locale === "fi") return fi_widget_show_more(inputs)
	if (locale === "hi") return hi_widget_show_more(inputs)
	if (locale === "ja") return ja_widget_show_more(inputs)
	if (locale === "nl") return nl_widget_show_more(inputs)
	if (locale === "pt") return pt_widget_show_more(inputs)
	if (locale === "ro") return ro_widget_show_more(inputs)
	if (locale === "th") return th_widget_show_more(inputs)
	if (locale === "ur") return ur_widget_show_more(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_show_more(inputs)
	if (locale === "da") return da_widget_show_more(inputs)
	if (locale === "it") return it_widget_show_more(inputs)
	if (locale === "vn") return vn_widget_show_more(inputs)
	if (locale === "ko") return ko_widget_show_more(inputs)
	if (locale === "tr") return tr_widget_show_more(inputs)
	if (locale === "lv") return lv_widget_show_more(inputs)
	if (locale === "ar") return ar_widget_show_more(inputs)
	if (locale === "bs") return bs_widget_show_more(inputs)
	if (locale === "sl") return sl_widget_show_more(inputs)
	if (locale === "id") return id_widget_show_more(inputs)
	if (locale === "sv") return sv_widget_show_more(inputs)
	return "widget_show_more"
};